import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import React, { Dispatch } from 'react';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../../redux/configureStore';
import getDashboard from '../../../../../redux/fetchActions/legadoPage/dashboardApp';
import SideButton from '../../../../../shared/components/SideMenu/components/SideButtons';
import AccountingApp from '../../AccountingApp';
import ApurationApp from '../../ApurationApp';
import CashInApp from '../../CashInApp';
import CashInAppV2 from '../../CashInAppV2';
import ClientsApp from '../../ClientsApp';
import DashboardApp from '../../DashboardApp';
import FaresApp from '../../FaresApp';
import LimitApp from '../../LimitApp';
import OutstandingDebits from '../../OutstandingDebitsApp';
import TransferApp from '../../TransferApp';
import { IReturnDashboardButton, ISetters } from './interfaces';

export function renderDashboardApp(
  dispatch: Dispatch<any>,
  setAppClientComponent: React.Dispatch<React.SetStateAction<any>>
) {
  dispatch(getDashboard());
  setAppClientComponent(<DashboardApp />);
}

export function renderClientsApp(
  setAppClientComponent: React.Dispatch<React.SetStateAction<any>>
) {
  setAppClientComponent(<ClientsApp />);
}

export function renderLimitApp(
  setAppLimitComponent: React.Dispatch<React.SetStateAction<any>>
) {
  setAppLimitComponent(<LimitApp />);
}

export function renderCashInApp(
  setAppLimitComponent: React.Dispatch<React.SetStateAction<any>>
) {
  setAppLimitComponent(<CashInApp />);
}

export function renderFaresApp(
  setAppClientComponent: React.Dispatch<React.SetStateAction<any>>
) {
  setAppClientComponent(<FaresApp />);
}

export function renderApurationApp(
  setAppClientComponent: React.Dispatch<React.SetStateAction<any>>
) {
  setAppClientComponent(<ApurationApp />);
}

export function renderOutstandingDebitsApp(
  setAppClientComponent: React.Dispatch<React.SetStateAction<any>>
) {
  setAppClientComponent(<OutstandingDebits />);
}

export function renderAccountingApp(
  setAppClientComponent: React.Dispatch<React.SetStateAction<any>>
) {
  setAppClientComponent(<AccountingApp />);
}

export function renderTransferApp(
  setAppClientComponent: React.Dispatch<React.SetStateAction<any>>
) {
  setAppClientComponent(<TransferApp />);
}

export function renderCashInAppV2(
  setAppClientComponent: React.Dispatch<React.SetStateAction<any>>
) {
  setAppClientComponent(<CashInAppV2 />);
}

export function ReturnDashboardButton(props: IReturnDashboardButton) {
  const profileUserContext = useSelector(
    (reducer: IReducer) => reducer.userProfile
  );

  if (profileUserContext.partnerId === 1) {
    return (
      <SideButton onClick={props.onClick} wasClicked={props.wasClicked}>
        <TrendingUpIcon />
        <span style={{ fontSize: '1rem' }}>Dashboard</span>
      </SideButton>
    );
  }
  return <></>;
}

export function ReturnAccountingAppButton(props: IReturnDashboardButton) {
  const profileUserContext = useSelector(
    (reducer: IReducer) => reducer.userProfile
  );

  if (profileUserContext.partnerId === 1 && profileUserContext.nivel === 2) {
    return (
      <SideButton onClick={props.onClick} wasClicked={props.wasClicked}>
        <MonetizationOnOutlinedIcon />
        <span>Contábil</span>
      </SideButton>
    );
  }
  return <></>;
}

export function setButtonIsClicked(buttonName: string, setters: ISetters) {
  switch (buttonName) {
    case 'dashboard':
      renderDashboardApp(setters.dispatch, setters.setAppComponent);
      setters.setDashboardIsClicked(true);
      setters.setClientsIsClicked(false);
      setters.setFaresIsClicked(false);
      setters.setLimitIsClicked(false);
      setters.setOutstandingDebitsClicked(false);
      setters.setAccountingIsClicked(false);
      setters.setCashInIsClicked(false);
      setters.setTransferIsClicked(false);
      setters.setApurationIsClicked(false);
      break;

    case 'clients':
      renderClientsApp(setters.setAppComponent);
      setters.setDashboardIsClicked(false);
      setters.setClientsIsClicked(true);
      setters.setFaresIsClicked(false);
      setters.setLimitIsClicked(false);
      setters.setOutstandingDebitsClicked(false);
      setters.setAccountingIsClicked(false);
      setters.setCashInIsClicked(false);
      setters.setTransferIsClicked(false);
      setters.setApurationIsClicked(false);
      break;

    case 'fares':
      renderFaresApp(setters.setAppComponent);
      setters.setDashboardIsClicked(false);
      setters.setClientsIsClicked(false);
      setters.setFaresIsClicked(true);
      setters.setLimitIsClicked(false);
      setters.setOutstandingDebitsClicked(false);
      setters.setAccountingIsClicked(false);
      setters.setCashInIsClicked(false);
      setters.setTransferIsClicked(false);
      setters.setApurationIsClicked(false);
      break;

    case 'outstanding':
      renderOutstandingDebitsApp(setters.setAppComponent);
      setters.setDashboardIsClicked(false);
      setters.setClientsIsClicked(false);
      setters.setFaresIsClicked(false);
      setters.setLimitIsClicked(false);
      setters.setOutstandingDebitsClicked(true);
      setters.setAccountingIsClicked(false);
      setters.setCashInIsClicked(false);
      setters.setTransferIsClicked(false);
      setters.setApurationIsClicked(false);
      break;

    case 'accounting':
      renderAccountingApp(setters.setAppComponent);
      setters.setDashboardIsClicked(false);
      setters.setClientsIsClicked(false);
      setters.setFaresIsClicked(false);
      setters.setLimitIsClicked(false);
      setters.setOutstandingDebitsClicked(false);
      setters.setAccountingIsClicked(true);
      setters.setCashInIsClicked(false);
      setters.setTransferIsClicked(false);
      setters.setApurationIsClicked(false);
      break;

    case 'apuration':
      renderApurationApp(setters.setAppComponent);
      setters.setDashboardIsClicked(false);
      setters.setClientsIsClicked(false);
      setters.setFaresIsClicked(false);
      setters.setLimitIsClicked(false);
      setters.setOutstandingDebitsClicked(false);
      setters.setAccountingIsClicked(false);
      setters.setCashInIsClicked(false);
      setters.setTransferIsClicked(false);
      setters.setApurationIsClicked(true);
      break;

    case 'limit':
      renderLimitApp(setters.setAppComponent);
      setters.setDashboardIsClicked(false);
      setters.setClientsIsClicked(false);
      setters.setFaresIsClicked(false);
      setters.setLimitIsClicked(true);
      setters.setOutstandingDebitsClicked(false);
      setters.setAccountingIsClicked(false);
      setters.setCashInIsClicked(false);
      setters.setApurationIsClicked(false);
      break;

    case 'cashIn':
      renderCashInApp(setters.setAppComponent);
      setters.setDashboardIsClicked(false);
      setters.setClientsIsClicked(false);
      setters.setFaresIsClicked(false);
      setters.setLimitIsClicked(false);
      setters.setOutstandingDebitsClicked(false);
      setters.setAccountingIsClicked(false);
      setters.setCashInIsClicked(true);
      setters.setApurationIsClicked(false);
      setters.setTransferIsClicked(false);
      break;

    case 'transfer':
      renderTransferApp(setters.setAppComponent);
      setters.setDashboardIsClicked(false);
      setters.setClientsIsClicked(false);
      setters.setFaresIsClicked(false);
      setters.setLimitIsClicked(false);
      setters.setOutstandingDebitsClicked(false);
      setters.setAccountingIsClicked(false);
      setters.setApurationIsClicked(false);
      setters.setCashInIsClicked(false);
      setters.setTransferIsClicked(true);
      setters.setCashinV2IsClicked(false);
      break;

    case 'cashInV2':
      renderCashInAppV2(setters.setAppComponent);
      setters.setDashboardIsClicked(false);
      setters.setClientsIsClicked(false);
      setters.setFaresIsClicked(false);
      setters.setLimitIsClicked(false);
      setters.setOutstandingDebitsClicked(false);
      setters.setAccountingIsClicked(false);
      setters.setApurationIsClicked(false);
      setters.setCashInIsClicked(false);
      setters.setTransferIsClicked(false);
      setters.setCashinV2IsClicked(true);
      break;

    default:
      break;
  }
}
